'use client';

import { Flex, Button, ButtonGroup, Input } from '@/_components';
import { EditRolloverItemProps } from './EditRolloverItem.types';
import {
  updatePriorYearItem,
  addPriorYearItem,
} from '@/_api/admin-prior-year-items';
import { type FC, useEffect, useContext, useState } from 'react';
import { ToastContext } from '@/_contexts/ToastProvider';
import { UserContext } from '@/_contexts/UserProvider';

export const EditRolloverItem: FC<EditRolloverItemProps> = ({
  rolloverItem,
  year,
  companyId,
  onDone,
}) => {
  const { token } = useContext(UserContext);
  const { addToast } = useContext(ToastContext);

  const [name, setName] = useState<string>(rolloverItem?.name || '');
  const [isLoading, setLoading] = useState<boolean>(false);

  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setName(event.target.value);

  const onCreate = async () => {
    console.log({ companyId });

    try {
      setLoading(true);
      await addPriorYearItem({
        companyId,
        name,
        year,
        token,
      });
    } catch (error) {
      addToast('error', null, { error });
    } finally {
      setLoading(false);
      onDone();
    }
  };

  const onEdit = async () => {
    try {
      setLoading(true);

      await updatePriorYearItem({
        id: rolloverItem?.id!,
        companyId,
        name,
        year,
        token,
      });
    } catch (error) {
      addToast('error', null, { error });
    } finally {
      setLoading(false);
      onDone();
    }
  };

  const onSave = () => {
    return rolloverItem?.id ? onEdit() : onCreate();
  };

  useEffect(() => {
    return () => {
      setName('');
    };
  }, []);

  return (
    <Flex isYCentered={true} gap={6}>
      <Input
        value={name}
        onChange={onInputChange}
        autoFocus={true}
        placeholder="Rollover Item"
        label="Rollover Item"
        isLabelHidden={true}
      />
      <ButtonGroup isSameLine={true} isSmallGroup={true}>
        <Button
          value="Cancel"
          size="small"
          intent="secondary"
          onClick={onDone}
          isDisabled={isLoading}
        />
        <Button
          value="Save"
          size="small"
          intent="primary"
          onClick={onSave}
          isDisabled={isLoading || !name}
          isLoading={isLoading}
        />
      </ButtonGroup>
    </Flex>
  );
};
